export const CUSTOM_SIMPLE_NODE = 'custom-simple'
